import { render } from "./MagicSignin.vue?vue&type=template&id=2b7a7204"
import script from "./MagicSignin.vue?vue&type=script&lang=js"
export * from "./MagicSignin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__